import { jupiterFetch } from '@svenskaspelab/nova-core/jupiter';
import { createLogger } from '@svenskaspelab/nova-core/log';
import { Roles } from '@svenskaspelab/nova-core/nextjs/auth';

const logger = createLogger('nova-account-tur:api-calls:session-end');

type SessionData = {
  readonly session: {
    role: string;
    authenticationLevel: string;
    loginType: string;
    deviceId: string;
    isBlocked: boolean;
    firstName: string;
    lastName: string;
    pamAccountName: string | null;
  };
};

export async function getUserSession(logout: () => Promise<void>): Promise<SessionData | undefined> {
  try {
    const response = await jupiterFetch('/user/1/sessions', {
      method: 'GET',
      credentials: 'include',
    });

    if (!response.ok) throw new Error(`HTTP ${response.status}`);

    const sessionData = (await response.json()) as SessionData;
    if (sessionData.session.role !== Roles.PLAYER) {
      logger.info('Prolonging session failed. Role not Player. logging out.');
      void logout();
      return undefined;
    }
    logger.info('User is still active, prolonging session');
    return sessionData;
  } catch (error) {
    logger.warn('Error prolonging session, logging out', {
      message: error instanceof Error ? error.message : 'Unknown error',
    });
    void logout();
  }
  return undefined;
}
